import { Constant, Headers } from "../apiConstants";

const GetPromoCodeInfo = async (couponCode, outletId) => {
  const endpoint = Constant.CHECK_COUPON_CODE_EXIST + `?couponCode=${couponCode}&outletId=${outletId}&sourceType=dinein`;
  const BaseUrl = Constant.BASE_URL;
  try {
    const response = await fetch(BaseUrl + "/" + endpoint, {
      method: "get",
      headers: Headers,
    });
    const responseData = await response.json();
    return responseData;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export default GetPromoCodeInfo;
